import React from 'react'

export const OmitGroups = () => (
  <path d='M7 10.9972V6.99722C6.99875 5.75727 7.45828 4.56109 8.28937 3.64089C9.12047 2.72069 10.2638 2.14213 11.4975 2.01751C12.7312 1.8929 13.9671 2.23113 14.9655 2.96654C15.9638 3.70195 16.6533 4.78207 16.9 5.99722M5 10.9972H19C20.1046 10.9972 21 11.8927 21 12.9972V19.9972C21 21.1018 20.1046 21.9972 19 21.9972H5C3.89543 21.9972 3 21.1018 3 19.9972V12.9972C3 11.8927 3.89543 10.9972 5 10.9972Z' />
)
